import { render } from "./AddServiceProfileModal.vue?vue&type=template&id=0c1e897c&ts=true"
import script from "./AddServiceProfileModal.vue?vue&type=script&lang=ts"
export * from "./AddServiceProfileModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__